import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Grid } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { EditGuestModal } from './EditGuestModal';
import { DeleteGuestModal } from './DeleteGuestModal';
import {
  deleteShareFileGuest,
  getShareFileGuestList
} from '../../../apicalls/cloud/shareFile';
import {
  deleteSharePictureGuest,
  getSharePictureGuestList
} from '../../../apicalls/cloud/sharePicture';
import { checkResData } from '../../../utils/common';
import type { TCurrentGuest } from '../../../types/CloudStorageModal';

type TProps = {
  currentGuest: TCurrentGuest;
  getGuestList: () => void;
};

export const CurrentGuestField = (props: TProps) => {
  const { currentGuest, getGuestList } = props;

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const classes = useStyles();

  const [openEditGuestModal, setOpenEditGuestModal] = useState<boolean>(false);
  const [openDeleteGuestModal, setOpenDeleteGuestModal] =
    useState<boolean>(false);

  const onDelete = () => {
    // 開いているページによって共有先を削除するAPIを変更
    const deleteGuest =
      history.location.pathname === '/files'
        ? deleteShareFileGuest
        : deleteSharePictureGuest;
    deleteGuest(currentGuest.id)
      .then(resData => {
        checkResData(resData, enqueueSnackbar);
      })
      .then(() => {
        // 開いているページによって共有状況（フォルダ単位）を取得するAPIを変更
        const getCurrentGuestList =
          history.location.pathname === '/files'
            ? getShareFileGuestList
            : getSharePictureGuestList;
        getCurrentGuestList(currentGuest.folder_id).then(res => {
          getGuestList();
          setOpenEditGuestModal(false);
        });
      });
  };

  return (
    <>
      <Grid container style={{ borderBottom: 'solid 1px' }}>
        <Grid item xs={8}>
          <p style={{ margin: '17px', overflowWrap: 'break-word' }}>
            {currentGuest.name}
          </p>
        </Grid>

        <Grid item xs={4}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end'
            }}
          >
            {currentGuest.uploadable ? (
              <div className={classes.uploadable}>
                <p style={{ margin: 0 }}>アップロード可能</p>
              </div>
            ) : (
              <div className={classes.disable}>
                <p style={{ margin: 0 }}>アップロード不可</p>
              </div>
            )}
            <p
              style={{
                margin: 17,
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={() => {
                setOpenEditGuestModal(true);
              }}
            >
              編集する
            </p>
            <CloseIcon
              style={{ cursor: 'pointer', color: '#999999', marginRight: 17 }}
              onClick={() => setOpenDeleteGuestModal(true)}
            />
          </div>
        </Grid>
      </Grid>

      {/* 編集モーダル */}
      <EditGuestModal
        currentGuest={currentGuest}
        getGuestList={getGuestList}
        openEditGuestModal={openEditGuestModal}
        setOpenEditGuestModal={setOpenEditGuestModal}
      />

      {/* 削除モーダル */}
      <DeleteGuestModal
        name={currentGuest.name}
        openDeleteGuestModal={openDeleteGuestModal}
        setOpenDeleteGuestModal={setOpenDeleteGuestModal}
        onDelete={onDelete}
      />
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    uploadable: {
      width: 140,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#52555f',
      backgroundColor: '#ffffff',
      border: 'solid 1px #52555f'
    },
    disable: {
      width: 140,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#bdbdbd',
      backgroundColor: '#ffffff',
      border: 'solid 1px #bdbdbd'
    }
  })
);
